import React from 'react'
import styles from './ToggleSwitch.module.css'

/**
 * ToggleSwitch
 *
 * Boolean on/off switch. Can render standalone or with a label
 * and description in a row (common pattern: settings list rows).
 *
 * Usage:
 *   <ToggleSwitch checked={form.isVisible} onChange={(v) => updateField('isVisible', v)} />
 *
 *   <ToggleSwitch
 *     label="Include blog posts"
 *     description="Add published blog posts to your sitemap"
 *     checked={form.includeBlogPosts}
 *     onChange={(v) => updateField('includeBlogPosts', v)}
 *   />
 */
const ToggleSwitch = ({
    checked,
    onChange,
    label,
    description,
    disabled = false,
    size = 'md' // 'sm' | 'md'
}) => {
    const handleClick = () => {
        if (!disabled) onChange?.(!checked)
    }

    const switchEl = (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            disabled={disabled}
            onClick={handleClick}
            className={`${styles.switch} ${size === 'sm' ? styles.switchSm : ''} ${checked ? styles.switchOn : ''} ${disabled ? styles.switchDisabled : ''}`}
        >
            <span className={styles.knob} />
        </button>
    )

    if (!label && !description) return switchEl

    return (
        <div className={styles.row}>
            <div className={styles.textCol}>
                {label && <div className={styles.label}>{label}</div>}
                {description && <div className={styles.description}>{description}</div>}
            </div>
            {switchEl}
        </div>
    )
}

export default ToggleSwitch